import { Component, Inject, Injector, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';

import { ActionService, AuthService, FileService, ISitemap, ResolverLoadingService, SITEMAP } from 'pbc.angular';

@Component({
  selector: 'fa-kt-kommunikation-badge',
  templateUrl: './kommunikation-badge.component.html',
  styleUrls: ['./kommunikation-badge.component.css'],
})
export class KommunikationBadgeComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];

  public readonly $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Input() set vermerke(vermerke: any[]) {
    this.$vermerke.next(vermerke || []);
  }
  @Input() set erinnerungen(erinnerungen: any[]) {
    this.$erinnerungen.next(erinnerungen || []);
  }
  $vermerke = new BehaviorSubject<any[]>([]);
  $erinnerungen = new BehaviorSubject<any[]>([]);
  count: string = '0';

  get modalRef() {
    return this.injector.get(NzModalRef);
  }

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private modal: NzModalService,
    private message: NzMessageService,
    private actions: ActionService,
    private loading: ResolverLoadingService,
    public auth: AuthService,
    public files: FileService,
  ) {}

  async ngOnInit() {
    this.subscriptions.push(
      ...[
        this.route.queryParams.subscribe(async (params: Params) => {}),
        /* << subscriptions    */
        combineLatest([this.$vermerke, this.$erinnerungen]).subscribe(([vermerke, erinnerungen]) => (this.count = vermerke.length + erinnerungen.length + '')),
        /*    subscriptions >> */
      ],
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }
}
